import { Button, Modal } from "semantic-ui-react";
import { IParameter } from "../../models/parameter";
import { publishParameter } from "../../services/parametersService";
import { toast } from "../..";

interface IProps {
    publishParameterModalOpen: boolean;
    closePublishParameterModal: () => void;
    parameterToPublish: IParameter;
    refreshParameters: () => void;
}

export const PublishParameterModal = ({
    publishParameterModalOpen,
    closePublishParameterModal,
    parameterToPublish,
    refreshParameters,
}: IProps) => {
    const handlePublishParameter = async () => {
        const response = await publishParameter(parameterToPublish.guid);
        if (response) {
            toast("Parameter published successfully", true, 2000);
            refreshParameters();
        } else {
            toast("Error publishing parameter", false, 2000);
        }
        closePublishParameterModal();
    };

    return (
        <Modal open={publishParameterModalOpen}>
            <Modal.Header>Publish parameter</Modal.Header>
            <Modal.Content>
                Are you sure you want to publish parameter {parameterToPublish.name}?
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={closePublishParameterModal} content="Cancel" />
                <Button primary onClick={handlePublishParameter} content="Publish" />
            </Modal.Actions>
        </Modal>
    );
};
